import { render, staticRenderFns } from "./capacityInputList.vue?vue&type=template&id=48cab794&scoped=true"
import script from "./capacityInputList.vue?vue&type=script&lang=js"
export * from "./capacityInputList.vue?vue&type=script&lang=js"
import style0 from "./capacityInputList.vue?vue&type=style&index=0&id=48cab794&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48cab794",
  null
  
)

export default component.exports